import { render, staticRenderFns } from "./PDFmodel.vue?vue&type=template&id=ead084a6&scoped=true&"
import script from "./PDFmodel.vue?vue&type=script&lang=js&"
export * from "./PDFmodel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead084a6",
  null
  
)

export default component.exports